import { getQueryParameters, getUsageParameters, getIncludeNotHeldParameter, getSimulateActionsNode, getAttributionMethodParameter, getContributorDescriptors, getAnalyticsOutputParameter } from "./helpers"

export function riskQuery(options = {}) {
  const parameters = [getAnalyticsOutputParameter(options)]
  return `query (${getQueryParameters(parameters)}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode(parameters)} {
        ${riskQueryFragment(options)}
      }
    }
  }`
}

// QueryFragments are called by the rebalanceQuery so they need to include OpPro checks which are normally done before even calling the query
export function riskQueryFragment(options = {}) {
  const { isOpPro } = options
  if (isOpPro) { return "" }
  return `risk {
    total
    attribution {
      summary {
        factors
        specific
      }
    }
  }`
}

export function riskContributorsQuery(options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const attributionMethodParameter = getAttributionMethodParameter(options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)

  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter, attributionMethodParameter])}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
        ${riskContributorsQueryFragment([includeNotHeldParameter, attributionMethodParameter], options)}
      }
    }
  }`
}

// QueryFragments are called by the rebalanceQuery so they need to include OpPro checks which are normally done before even calling the query
export function riskContributorsQueryFragment(parameters = [], options = {}) {
  const { isOpPro } = options
  if (isOpPro) { return "" }
  return `riskContributors${getUsageParameters(parameters, true)} {
    ${getContributorDescriptors()}
    total
    attribution {
      summary {
        factors
        specific
      }
    }
  }`
}

export function groupedRiskContributorsQuery(options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const attributionMethodParameter = getAttributionMethodParameter(options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)

  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter, attributionMethodParameter], true)}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
        ${groupedRiskContributorsQueryFragment([includeNotHeldParameter, attributionMethodParameter], options)}
      }
    }
  }`
}

// QueryFragments are called by the rebalanceQuery so they need to include OpPro checks which are normally done before even calling the query
export function groupedRiskContributorsQueryFragment(parameters = [], options = {}) {
  const { isOpPro } = options
  if (isOpPro) { return "" }
  return `groupedRiskContributors(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier ${getUsageParameters(parameters)}) {
    id
    name
    attribution {
      summary {
        factors
        specific
      }
    }
    contributors{
      ${getContributorDescriptors()}
      total
      attribution {
        summary {
          factors
          specific
        }
      }
    }
  }`
}
